import { useLayoutEffect, useRef, useState } from 'react';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
type ScreenSize = {
  screen: Size | null;
  isMobile: boolean;
  isSmallerDevice: boolean;
};

const breakpoints = {
  xs: 576,
  sm: 768,
  md: 992,
  xl: 1400,
  xxl: 1600,
  xxxl: 2000,
};

export function useScreenSize(): ScreenSize {
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [screen, setScreen] = useState<Size | null>(null);
  const [innerWidth, setInnerWidth] = useState(self.innerWidth);

  function determineSize() {
    setInnerWidth(self.innerWidth);
    if (self.innerWidth <= breakpoints.xs) {
      setScreen('xs');
      return;
    }
    if (self.innerWidth <= breakpoints.sm) {
      setScreen('sm');
      return;
    }
    if (self.innerWidth <= breakpoints.md) {
      setScreen('md');
      return;
    }
    if (self.innerWidth <= breakpoints.xl) {
      setScreen('lg');
      return;
    }
    if (self.innerWidth <= breakpoints.xxl) {
      setScreen('xl');
      return;
    }

    if (self.innerWidth <= breakpoints.xxxl) {
      setScreen('xxl');
      return;
    }

    setScreen('xxxl');
  }

  function handleResize() {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(determineSize, 500);
  }

  useLayoutEffect(() => {
    determineSize();

    window.addEventListener('resize', handleResize);
    return () => window.addEventListener('resize', handleResize);
  }, []);

  const isMobile = innerWidth < breakpoints.md;
  const isSmallerDevice = innerWidth < 1280;

  return {
    screen,
    isMobile,
    isSmallerDevice,
  };
}
